import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Overview from "./components/Overview";
import { useLanguageSwitch } from "../../hooks/useLanguageSwitch";
import { clearPISessionStorage } from "../../helpers/shared/sessionStorage";

type Props = {
  isNewTranslationFlow?: boolean;
};

const PIOverview: FC<Props> = ({ isNewTranslationFlow = false }) => {
  useEffect(() => {
    clearPISessionStorage("professional_indemnity/manulife");
    clearPISessionStorage("professional_indemnity/manulifesv");
  }, []);

  useLanguageSwitch({ enabled: isNewTranslationFlow, language: "zh" });
  const { t } = useTranslation("pages", { keyPrefix: "professionalIndemnity.overview" });

  return <Overview content={t} flow="" isManulifeSv={isNewTranslationFlow} />;
};

export default PIOverview;
